// extracted by mini-css-extract-plugin
export default {"topNavBox_right":"TopNavRightBox_topNavBox_right__BBI2W","wrapper":"TopNavRightBox_wrapper__9f9q4"};